<template>
  <label class="flex justify-start items-center cursor-pointer" :for="identity">
    <div
      class="bg-form border-2 placeholder-gray-400 border-blacky rounded-md w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 focus:border-primary"
    >
      <input
        type="checkbox"
        class="opacity-0 absolute"
        :id="identity"
        :name="identity"
        :checked="isChecked"
        :value="value"
        @change="handleChange($event.target.checked)"
      />
      <svg class="fill-current hidden w-3 h-3 text-secondary pointer-events-none" viewBox="0 0 20 20">
        <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
      </svg>
    </div>
    <p class="pl-10px max-w-60.25 md:max-w-full mb-0 text-blacky" v-text="label" />
  </label>
</template>
<script>
export default {
  name: "CheckField",
  model: {
    prop: "modelValue",
    event: "change",
  },
  props: {
    checked:{
      default:false,
    },
    identity: {
      default: "",
    },
    value: {
      default: false,
    },
    modelValue: {
      default: "",
    },
    label: {
      type: String,
      required: true,
    },
    trueValue: {
      default: true,
    },
    falseValue: {
      default: false,
    },
  },
  methods: {
    handleChange(_isChecked) {
      if(!this.isDesabled)
       { if (this.modelValue instanceof Array) {
          let newValue = [...this.modelValue];
          if (_isChecked) {
            newValue.push(this.value);
          } else {
            newValue.splice(newValue.indexOf(this.value), 1);
          }
          this.$emit("change", newValue);
        } else {
          this.$emit("change", _isChecked ? this.trueValue : this.falseValue);
        }}
    },
  },
  computed: {
    isChecked() {
      return this.checked instanceof Array
        ? this.checked.includes(this.value)
        : this.checked === this.trueValue;
    },
  },
};
</script>
<style scoped>
input:checked + svg {
  display: block;
}

</style>
